import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=708a1422&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=js&"
export * from "./Record.vue?vue&type=script&lang=js&"
import style0 from "./Record.vue?vue&type=style&index=0&id=708a1422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a1422",
  null
  
)

export default component.exports